// 목록 카드 본문 미리보기 생성 — 마크다운·HTML을 벗겨 평문만 남긴다.
//
// 🔴 D-6②(2026-09-01 SE3 실기): 목록 미리보기는 마크다운을 렌더하지 않는데 원문을 그대로 잘라 써서
//    황둥이 정기글 카드에 "## 📊 한 줄 요약 … **-1.79%**"처럼 기호가 노출됐다.
//    본문 렌더(상세 화면)와는 별개 경로이므로 여기서 기호를 제거한다.

/** 마크다운 기호를 벗겨 한 줄 평문으로 만든다. 표시용이므로 완전한 파서가 아니라 기호 제거만 한다. */
export function stripMarkdown(raw: string): string {
  let t = String(raw);

  // 코드펜스 ```lang … ``` — 내용까지 통째로 버린다(미리보기에 코드가 들어가도 읽히지 않는다)
  t = t.replace(/```[\s\S]*?```/g, ' ');
  // HTML 태그 (기존 동작 유지 — content_format이 html인 글이 섞여 있다)
  t = t.replace(/<[^>]+>/g, ' ');
  // 이미지 ![alt](url) → alt 텍스트도 미리보기에선 잡음이라 통째로 제거
  t = t.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ');
  // 링크 [텍스트](url) → 텍스트만
  t = t.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1');
  // 수평선 --- / *** / ___ (한 줄 전체)
  t = t.replace(/^\s*([-*_])\s*(?:\1\s*){2,}$/gm, ' ');
  // 제목 ###, 인용 >, 목록 -/*/+, 번호목록 1. — 줄 앞머리 기호만
  t = t.replace(/^\s{0,3}#{1,6}\s+/gm, ' ');
  t = t.replace(/^\s{0,3}>+\s?/gm, ' ');
  t = t.replace(/^\s{0,3}[-*+]\s+/gm, ' ');
  t = t.replace(/^\s{0,3}\d+[.)]\s+/gm, ' ');
  // 강조 **볼드** __볼드__ *이탤릭* _이탤릭_ ~~취소선~~ `코드`
  t = t.replace(/\*\*([^*]+)\*\*/g, '$1');
  t = t.replace(/__([^_]+)__/g, '$1');
  t = t.replace(/\*([^*\n]+)\*/g, '$1');
  t = t.replace(/_([^_\n]+)_/g, '$1');
  t = t.replace(/~~([^~]+)~~/g, '$1');
  t = t.replace(/`([^`]+)`/g, '$1');
  // 표 구분선 |---|---| 과 셀 구분자 파이프
  t = t.replace(/^\s*\|?[\s:|-]{5,}\|?\s*$/gm, ' ');
  t = t.replace(/\|/g, ' ');

  return t.replace(/\s+/g, ' ').trim();
}

/** 글 본문에서 목록 카드용 발췌를 만든다. 표시할 게 없으면 null. */
export function postExcerpt(content: unknown, maxLen = 90): string | null {
  if (!content) return null;
  const text = stripMarkdown(String(content));
  return text ? text.slice(0, maxLen) : null;
}
